import { render, staticRenderFns } from "./importForm.vue?vue&type=template&id=e78e1740&scoped=true"
import script from "./importForm.vue?vue&type=script&lang=js"
export * from "./importForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78e1740",
  null
  
)

export default component.exports